module.exports = __webpack_public_path__ + "img/qrcode-zyzlcx.3858a866.jpg";